var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('div',{staticClass:"section-wrapper"},[_c('div',{staticClass:"section-title"},[_vm._v(" 六. "+_vm._s(_vm.entityJson.name)+" ")]),_c('div',{staticClass:"table"},[_c('ChangeLogMoreTable',{attrs:{"data":_vm.entityJson.data}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }